import ApiHelper from "../../utilities/ApiHelper";


// simulationSearch
export function searchSimulations(data: { query: string; topK: number;instituteId:string }) {
  return new Promise((resolve, reject) => {
    ApiHelper.get(`/api/v1/getSimulations/${data.instituteId}/?query=${data.query}&topK=${data.topK}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

// generateAIModel
export function generateAIModel(data?: { prompt?: string }) {
  return new Promise((resolve, reject) => {
    ApiHelper.post(`api/v1/aiModelGenerator/generateModel`, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

// chat
export function getChatCompletion(data: { 
    messages: Array<{ role: string; content: string }>;
    systemPrompt: string;
  }) {
    return fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY??""}`
      },
      body: JSON.stringify({
        model: "gpt-3.5-turbo",
        messages: [
          { role: 'system', content: data.systemPrompt },
          ...data.messages
        ],
        temperature: 0.7,
      })
    }).then(response => response.json());
  } 

  //check whether coins are sufficient or not

  export function checkIfCoinsSufficient(data: { instituteId: string }) {
    return new Promise((resolve, reject) => {
      ApiHelper.get(`/api/v1/institute/checkCoinsAreEnough/${data.instituteId}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  }

    //check whether coins are sufficient or not
  
    export function updateCoinsOfInstitute(data: { instituteId: string,coins:number }) {
      return new Promise((resolve, reject) => {
        ApiHelper.put(`/api/v1/institute/updateCoins/${data.instituteId}`,{coins:data.coins})
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }